export default __webpack_public_path__ + "ca3e08bda718f852c32068cfbf9dab31.svg";